export function LeadUnreadBadge ({ count }) {
  if (!count || count < 1) return null;
  return (
    <span
      title={`${count} непрочитанных`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 16,
        height: 16,
        padding: '0 4px',
        borderRadius: 8,
        backgroundColor: '#ef4444',
        color: '#fff',
        fontSize: 11,
        fontWeight: 700,
        lineHeight: 1,
        flexShrink: 0,
      }}
    >
      !
    </span>
  );
}
